import { ContentsClient } from '../api/api-client';
import { DecryptedContent } from '../hooks/useContents';
import { CryptoHelper } from './cryptoHelper';
import { ErrorHandler } from './errorHandler';
import confirm from '../components/ConfirmModal';
import { Row, Col, Input } from 'reactstrap';

export const deleteThreadWithConfirmation = async (thread: DecryptedContent): Promise<void> => {
  if (!thread.id) throw new Error('Thread ID is required');

  const confirmed = await confirm({
    title: 'Delete Thread?',
    message: `Are you sure you want to delete thread ${thread.decryptedTitle}? This cannot be undone.`
  });

  if (confirmed) {
    const client = new ContentsClient();
    await client.deleteContent(thread.id);
    // SignalR will notify and refresh the thread list automatically
    
    ErrorHandler.showSuccess('Thread deleted successfully');
  }
};

export const renameThreadWithConfirmation = async (thread: DecryptedContent): Promise<void> => {
  if (!thread.id) throw new Error('Thread ID is required');
  if (!thread.contentKey) throw new Error('Cannot rename thread without content key');

  let newTitle = thread.decryptedTitle || '';
  
  const confirmed = await confirm({
    title: 'Rename Thread',
    message: <>
      <Row className="align-items-center">
        <Col xs="auto">Thread Title:</Col>
        <Col>
          <Input defaultValue={newTitle} placeholder="Enter thread title" 
                 onChange={(e) => { newTitle = e.target.value; }} />
        </Col>
      </Row>
    </>
  });

  if (confirmed && newTitle.trim()) {
    const encryptedTitle = await CryptoHelper.encryptContent(newTitle.trim(), thread.contentKey);
    const client = new ContentsClient();
    await client.updateTitle(thread.id, encryptedTitle);
    // SignalR will notify and refresh the thread list automatically
    
    ErrorHandler.showSuccess('Thread renamed successfully');
  }
};